export default __webpack_public_path__ + "static/media/edit.7138a914.svg";